<template>
  <div class="stock-status-step">
    <el-steps :active="activeIndex" finish-status="success" align-center="">
      <el-step
        v-for="status in this.showStatusList"
        :key="status.key"
        :title="status.value"
      />
    </el-steps>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'stock-status-step',
  props: {
    orderType: {
      type: String,
      default: ''
    },
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      stockStatusList: state => state.base.stockOrderStatusMap,
      quotaStatusList: state => state.base.quotaOrderStatusMap,
      logiticsStatusList: state => state.base.logisticsOrderStatusMap,
      applyStatusList: state => state.base.stockApplyOrderStatusMap
    }),
    showStatusList () {
      if (
        !this.stockStatusList ||
        !this.quotaStatusList ||
        !this.logiticsStatusList ||
        !this.applyStatusList
      ) {
        return
      }
      switch (this.orderType) {
        case 'stock':
          return this.handleStatusData(this.stockStatusList)
        case 'quota':
          return this.handleStatusData(this.quotaStatusList)
        case 'money':
          return this.handleStatusData(this.quotaStatusList)
        case 'logitics':
          return this.handleStatusData(this.logiticsStatusList)
        case 'apply':
          return this.handleStatusData(this.applyStatusList)
        default:
          return []
      }
    },
    activeIndex () {
      let status = null
      if (!this.orderInfo) {
        return -1
      }
      if (!this.showStatusList) {
        return
      }
      switch (this.orderType) {
        case 'stock':
          status = this.orderInfo.billStatus
          break
        case 'apply':
          status = this.orderInfo.applyStatus
          break
        default:
          status = this.orderInfo.orderStatus
          break
      }
      for (let i = 0; i < this.showStatusList.length; i++) {
        if (this.showStatusList[i].key === String(status)) {
          return i
        }
      }

      return -1
    }
  },
  created () {
    this.$store.dispatch('getDictByName', 'stockOrderStatusMap')
    this.$store.dispatch('getDictByName', 'quotaOrderStatusMap')
    this.$store.dispatch('getDictByName', 'logisticsOrderStatusMap')
    this.$store.dispatch('getDictByName', 'stockApplyOrderStatusMap')
  },
  methods: {
    handleStatusData (statusList) {
      const filterData = statusList.filter(item => {
        return item.key !== '900' && item.key !== '1000'
      })
      return filterData
    }
  }
}
</script>

<style lang="scss" scoped>
.stock-status-step {
  border-top: solid 1px $base-grey3;
  border-bottom: solid 1px $base-grey3;
  padding: 30px;

  ::v-deep .el-step__head.is-process {
    color: $base-red;
    border-color: $base-red;
  }
  ::v-deep .el-step__title.is-process {
    color: $base-red;
  }
}
</style>
